import { render, staticRenderFns } from "./wangEditor.vue?vue&type=template&id=0c6e6d8f&scoped=true&lang=html"
import script from "./wangEditor.vue?vue&type=script&lang=js"
export * from "./wangEditor.vue?vue&type=script&lang=js"
import style0 from "./wangEditor.vue?vue&type=style&index=0&id=0c6e6d8f&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e6d8f",
  null
  
)

export default component.exports